import UserDefaultLogo from "../../../assets/svg/user-avatar.svg";
import { UserRole } from "../../user/enums/UserRole";
import {
  IConversationBackEndModel,
  IConversationFrontEndModel,
} from "../types";
import SchoolDefaultLogo from "../../../assets/img/school-default-logo.png";

/**
 * @param behalfUserRole The user role, in behalf of which the messages page is opened
 */
export function parseToConversationsFrontEndModel(
  receivedConversations: IConversationBackEndModel[],
  behalfUserRole:
    | UserRole.School
    | UserRole.ServiceProvider
    | UserRole.Teacher
    | UserRole.Student,
): IConversationFrontEndModel[] {
  const defaultPhoto = [
    UserRole.School,
    UserRole.ServiceProvider,
    UserRole.Teacher,
  ].includes(behalfUserRole)
    ? UserDefaultLogo
    : SchoolDefaultLogo;

  return receivedConversations.map((conversation) => {
    const isMine = conversation.lastMessageAuthorRole === behalfUserRole;

    const text = (isMine ? "You: " : "") + (conversation.text || "Attachment");

    return {
      id:
        conversation.school?.id ||
        conversation.serviceProvider?.id ||
        conversation.teacher?.id ||
        conversation.student?.id ||
        "",
      name:
        conversation.school?.name ||
        conversation.serviceProvider?.name ||
        conversation.teacher?.name ||
        conversation.student?.name ||
        "",
      photo:
        conversation.school?.image?.preview ||
        conversation.serviceProvider?.image?.preview ||
        conversation.teacher?.photo?.preview ||
        conversation.student?.photo?.preview ||
        defaultPhoto,
      userRole: conversation.school
        ? UserRole.School
        : conversation.serviceProvider
          ? UserRole.ServiceProvider
          : conversation.teacher
            ? UserRole.Teacher
            : UserRole.Student,
      text: conversation.created_at ? text : "No messages",
      created_at: conversation.created_at,
      isSeen: conversation.isSeen,
      messages: [],
      temp: {
        text: "",
        attachments: [],
      },
    };
  });
}
